/* eslint-disable no-nested-ternary */
import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../ArchitectEngineer.module.scss';
import metadata from './BusinessOperationComponent.metadata.json5';
import PartnersOfficersEmployersComponent from '../subcomponents/PartnersOfficersEmployers/PartnersOfficersEmployersComponent'
import BusinessServicesComponent from '../subcomponents/BusinessServices/BusinessServicesComponent';
import FrmrFirmComponent from '../subcomponents/FrmrFirm/FrmrFirmComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function BusinessOperationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BusinessOperationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const getTotalNoOfEmployees = () => {
            const empCan = _.isUndefined(modelVM.value.noOfEmpInCan13) ? 0 : 
            (modelVM.value.noOfEmpInCan13 === '' ? 0 : modelVM.value.noOfEmpInCan13)
           
            const empUSA = _.isUndefined(modelVM.value.noOfEmpInUs14) ? 0 : 
            (modelVM.value.noOfEmpInUs14 === '' ? 0 : modelVM.value.noOfEmpInUs14)

            const empOthers = _.isUndefined(modelVM.value.noOfEmpInOthCou15) ? 0 : 
            (modelVM.value.noOfEmpInOthCou15 === '' ? 0 : modelVM.value.noOfEmpInOthCou15)

            modelVM.value.totNoOfEmp16 = empCan + empUSA + empOthers;
            
            return empCan + empUSA + empOthers;
        }

        const getTotalPerOfAllServices = () => {
            let total = 0;

            if(modelVM.value.businessServicesDTO.length > 0) {
                modelVM.value.businessServicesDTO.forEach(element => {
                    total += element.per2;
                });
            }            
            
            modelVM.value.totPerOfAllSer = total;
            
            return total;
        }

        const getTotalNoOfParOffEmp = () => {
            const total = modelVM.value.partnersOfficersEmployersDTO.length > 0 ?
            modelVM.value.partnersOfficersEmployersDTO.length : 0

            modelVM.value.totNoOfParOffEmp18 = total;
            
            return total;

        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifOthPleExp7: {
            visible: !_.isUndefined(modelVM.value.comStr6) && modelVM.value.comStr6 === 'Oth'
        },
        totNoOfEmp16: {
            value: getTotalNoOfEmployees(),
            disabled: true
        },
        totNoOfParOffEmp18: {
            value: getTotalNoOfParOffEmp(),
            disabled: true
        },
        ifYesPleProDet20: {
            visible: !_.isUndefined(modelVM.value.havAnyParOffEmpEmpEve19) && modelVM.value.havAnyParOffEmpEmpEve19
        },
        ifNoPleExp22: {
            visible: !_.isUndefined(modelVM.value.areAllEmpCovByWC21) && !modelVM.value.areAllEmpCovByWC21
        },
        ifSoPleProMorDet24: {
            visible: !_.isUndefined(modelVM.value.doeAnyOneCliRepMorTha23) && modelVM.value.doeAnyOneCliRepMorTha23
        },
        isAllSurAndMeaEquMai26: {
            visible: !_.isUndefined(modelVM.value.doeTheAppUseAnySurAnd25) && modelVM.value.doeTheAppUseAnySurAnd25
        },
        pleProDetExp28: {
            visible: !_.isUndefined(modelVM.value.doeTheAppOrRelParEng27) && modelVM.value.doeTheAppOrRelParEng27
        },
        wheAreTheLoc30: {
            visible: !_.isUndefined(modelVM.value.doeTheAppComHavLocOr29) && modelVM.value.doeTheAppComHavLocOr29
        },
        whaSerArePro31: {
            visible: !_.isUndefined(modelVM.value.doeTheAppComHavLocOr29) && modelVM.value.doeTheAppComHavLocOr29
        },
        whaPerOfGroRevAreDer32: {
            visible: !_.isUndefined(modelVM.value.doeTheAppComHavLocOr29) && modelVM.value.doeTheAppComHavLocOr29
        },
        totPerOfAllSer: {
            value: getTotalPerOfAllServices(),
            disabled: true
        },
        pleExp37: {
            visible: !_.isUndefined(modelVM.value.worConWitMin36) && modelVM.value.worConWitMin36 > 0
        },
        pleExp39: {
            visible: !_.isUndefined(modelVM.value.worRelToAerAviAir38) && modelVM.value.worRelToAerAviAir38 > 0
        },
        pleExp41: {
            visible: !_.isUndefined(modelVM.value.worOnBriTun40) && modelVM.value.worOnBriTun40 > 0
        },
        pleExp43: {
            visible: !_.isUndefined(modelVM.value.worOnCarPar42) && modelVM.value.worOnCarPar42 > 0
        },
        pleExp45: {
            visible: !_.isUndefined(modelVM.value.worConWitStaFouOrSho44) && modelVM.value.worConWitStaFouOrSho44 > 0
        },
        pleExp47: {
            visible: !_.isUndefined(modelVM.value.worConWitDesOfSewWat46) && modelVM.value.worConWitDesOfSewWat46 > 0
        },
        pleExp49: {
            visible: !_.isUndefined(modelVM.value.worConWitDam48) && modelVM.value.worConWitDam48 > 0
        },
        pleExp51: {
            visible: !_.isUndefined(modelVM.value.marRelWor50) && modelVM.value.marRelWor50 > 0
        },
        pleExp53: {
            visible: !_.isUndefined(modelVM.value.asbRelWor52) && modelVM.value.asbRelWor52 > 0
        },
        pleExp55: {
            visible: !_.isUndefined(modelVM.value.envWor54) && modelVM.value.envWor54 > 0
        },
        pleExp57: {
            visible: !_.isUndefined(modelVM.value.worNotResInConIeRep56) && modelVM.value.worNotResInConIeRep56 > 0
        },
        pleExp59: {
            visible: !_.isUndefined(modelVM.value.seiWor58) && modelVM.value.seiWor58 > 0
        },
        pleExp61: {
            visible: !_.isUndefined(modelVM.value.worConToPetOrOilAnd60) && modelVM.value.worConToPetOrOilAnd60 > 0
        },
        pleExp63: {
            visible: !_.isUndefined(modelVM.value.worOnMulResBui62) && modelVM.value.worOnMulResBui62 > 0
        },
        pleExp65: {
            visible: !_.isUndefined(modelVM.value.worOnAmuRid64) && modelVM.value.worOnAmuRid64 > 0
        },
        pleExp67: {
            visible: !_.isUndefined(modelVM.value.worOnPubTraStaTheAud66) && modelVM.value.worOnPubTraStaTheAud66 > 0
        },
        pleExp69: {
            visible: !_.isUndefined(modelVM.value.womInsRelToHomUpFor68) && modelVM.value.womInsRelToHomUpFor68 > 0
        },
        pleExp71: {
            visible: !_.isUndefined(modelVM.value.pla70) && modelVM.value.pla70 > 0
        },
        pleExp73: {
            visible: !_.isUndefined(modelVM.value.othOpe72) && modelVM.value.othOpe72 > 0
        },
        pleExp75: {
            visible: !_.isUndefined(modelVM.value.isTheAppAntAnyChaIn74) && modelVM.value.isTheAppAntAnyChaIn74 > 0
        },        
        partnersOfficersEmployersComponent: {
            data: modelVM.partnersOfficersEmployersDTO,
            updateWizardData,
            submissionVM,
            PartnersOfficersEmployersPath: `${pathUpdated}.partnersOfficersEmployersDTO`
        },
        businessServicesComponent: {
            data: modelVM.businessServicesDTO,
            updateWizardData,
            submissionVM,
            BusinessServicesPath: `${pathUpdated}.businessServicesDTO`
        },
        frmerFirmComponent: {
            data: modelVM.formerPredecessorFirmsDTO,
            updateWizardData,
            submissionVM,
            BusinessServicesPath: `${pathUpdated}.formerPredecessorFirmsDTO`
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            partnersOfficersEmployersComponent: PartnersOfficersEmployersComponent,
            businessServicesComponent: BusinessServicesComponent,
            frmerFirmComponent: FrmrFirmComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BusinessOperationComponent.propTypes = wizardProps;
export default withRouter(BusinessOperationComponent);
